module.exports = __webpack_public_path__ + "src/assets/img/warranty_card2.c78e4d37.jpg";